import React from 'react';
import { Filter, Table, TableContainer } from '@odin-labs/components';
import {
  AttendanceColumn,
  ScheduleShift,
} from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import { useJobsiteSchedules } from 'containers/jobsite/tabs/jobsiteSchedules/components/jobsiteSchedulesProvider';
import { usePageQueryParams } from 'utils/usePageQueryParams';
import { getColumns, getFilterItems } from './ScheduleAttendanceTable.tables';
import { ScheduleAttendanceFilters } from './types';

export function ScheduleAttendanceTable(props: {
  shift: ScheduleShift;
}): React.ReactElement {
  const { shift } = props;
  const { loading } = useJobsiteSchedules();

  const { attendanceStatuses, updateUrl } = usePageQueryParams();

  const columns = React.useMemo<AttendanceColumn[]>(() => getColumns(), []);

  const attendance = React.useMemo(() => {
    return shift.attendance?.edges.map(({ node }) => node) ?? [];
  }, [shift]);

  const filterItems = React.useMemo(
    () =>
      getFilterItems({
        attendanceStatuses,
      }),
    [attendanceStatuses],
  );

  const onFilterChangeHandler = (
    changedFilters: Partial<ScheduleAttendanceFilters>,
  ): void => {
    updateUrl({
      page: null,
      ...changedFilters,
    });
  };

  return (
    <TableContainer>
      <div className="odin-w-full odin-flex odin-gap-4">
        <Filter
          items={filterItems}
          loading={loading}
          onChange={onFilterChangeHandler}
        />
      </div>
      <Table
        columns={columns}
        data={attendance}
        disableGlobalFilter
        loading={loading}
        loadingRowCount={shift?.attendance?.count ?? 5}
        remote
      />
    </TableContainer>
  );
}
